<template>
  <div>
    <div class="head">
      <div class="mine-info" v-if="userinfo">
        <div class="mine-head-img" @click="$router.push('editUser')">
          <van-image
            round
            fit="cover"
            width="100%"
            height="100%"
            :src="userinfo.avatar"
            alt=""
          />
          <div class="edit-head-img">
            <i class="iconfont icon-bi"></i>
          </div>
        </div>
        <div class="mine-name">{{ userinfo.name }}</div>
        <div class="integral" @click="$router.push('recharge')">
          <img src="../../assets/mine/jb.png" alt="" />
          <span>{{ userinfo.gold }}</span>
          <i class="iconfont icon-a-LeftArrow"></i>
        </div>
      </div>
      <div class="mine-info" v-else @click="$router.push('login')">
        <div class="mine-head-img">
          <!-- <img src="../../assets/mine/default_head.png" /> -->
          <img src="mine-head-img" ref="h1ele">
        </div>
        <div class="mine-name" style="margin-top: 0.3rem">未登录,点击登录</div>
      </div>
    </div>
    <div class="yf">
      <div @click="$router.push('/coupon')">
        <img src="../../assets/mine/yhj.png" alt="" />
        <span>优惠券</span>
      </div>
      <div @click="$router.push('minefb')">
        <img src="../../assets/mine/fb.png" alt="" />
        <span>我的发布</span>
      </div>
    </div>

    <div class="mine-number">
      <div @click="$router.push({ path: '/focus', query: { type: 1 } })">
        <div class="mine-num">
          {{ userinfo && userinfo.followNum ? userinfo.followNum : 0 }}
        </div>
        <div class="mine-num-text">关注</div>
      </div>
      <div class="fg-line"></div>
      <div @click="$router.push({ path: '/focus', query: { type: 2 } })">
        <div class="mine-num">
          {{ userinfo && userinfo.fansNum ? userinfo.fansNum : 0 }}
        </div>
        <div class="mine-num-text">粉丝</div>
      </div>
      <div class="fg-line"></div>
      <div @click="$router.push('collection')">
        <div class="mine-num">
          {{ userinfo && userinfo.collectionNum ? userinfo.collectionNum : 0 }}
        </div>
        <div class="mine-num-text">收藏</div>
      </div>
    </div>

    <div class="order">
      <div class="my-order">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>我的订单</div>
          </div>
        </div>
      </div>
      <div class="order-type">
        <div @click="$router.push('orderzx')">
          <div class="order-num">
            <p>咨询订单</p>
            <p class="order-n">
              {{ userinfo && userinfo.zxConduct ? userinfo.zxConduct : 0 }}
            </p>
          </div>
          <img src="../../assets/mine/zxorder.png" alt="" />
        </div>
        <div @click="$router.push('orderaw')">
          <div class="order-num">
            <p>问答订单</p>
            <p class="order-n">
              {{ userinfo && userinfo.wdConduct ? userinfo.wdConduct : 0 }}
            </p>
          </div>
          <img src="../../assets/mine/wdorder.png" alt="" />
        </div>
        <div @click="$router.push('kcOrder')">
          <div class="order-num">
            <p>课程订单</p>
            <p class="order-n">
              {{ userinfo && userinfo.kcConduct ? userinfo.kcConduct : 0 }}
            </p>
          </div>
          <img src="../../assets/mine/kcorder.png" alt="" />
        </div>
      </div>
    </div>

    <div class="menu">
      <div
        class="menu-item"
        :class="item.id == 3 && userinfo && userinfo.service == 1 ? 'none' : ''"
        v-for="item in menu"
        :key="item.id"
        @click="jumpMenu(item)"
      >
        <div class="left-icon">
          <img :src="item.url" alt="" />
        </div>
        <div class="menu-title">{{ item.title }}</div>
        <div class="menu-more">
          <i class="iconfont icon-a-LeftArrow"></i>
        </div>
      </div>
      <div class="menu-item outlogin" @click="signOut" v-show="userinfo">
        <div class="menu-title">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:
@createTime:2021-08-12
@create:wq
*/
import {HERF} from '@/utils/tool.js'
import { shareJsSdk} from "@/utils/tool";
export default {
  name: "mine",
  props: {},
  components: {},
  data() {
    return {
      userinfo: JSON.parse(localStorage.getItem("user")),
      roomId: "",
      menu: [
        {
          id: 1,
          title: "合作推广",
          url: require("../../assets/mine/menu/1.png"),
          path: "/spread",
        },
        // {
        //   id: 2,
        //   title: "老师招募",
        //   url: require("../../assets/mine/menu/2.png"),
        //   path: "/recruit",
        // },
        {
          id: 3,
          title: "联系我们",
          url: require("../../assets/mine/menu/3.png"),
          path: "",
        },
        {
          id: 4,
          title: "用户协议",
          url: require("../../assets/mine/menu/4.png"),
          path: "/agreement",
        },
        {
          id: 5,
          title: "投诉反馈",
          url: require("../../assets/mine/menu/5.png"),
          path: "/feedback",
        },
        // {
        //   id: 6,
        //   title: "给app评价",
        //   url: require("../../assets/mine/menu/6.png"),
        // },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (this.userinfo) {
      this.getUserInfo();
      this.msgPageNum();
    }
    shareJsSdk('mine','可以测','国学传统文化 在线一对一咨询平台')
    this.$nextTick((callback=>{
      if(this.$refs.h1ele){
        this.$refs.h1ele.src = HERF+'/backstage/sx/'+this.getRandomInt(1,13)+'.png'
      }
    }))
    
  },
  methods: {
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min; //不含最大值，含最小值
    },
    msgPageNum() {
      this.api.msgPageNum().then((res) => {
        this.$store.dispatch("app/setNum", res.data.msgPageNum);
      });
    },
    jumpMenu(item) {
      if (!this.userinfo) {
        this.$router.push("/login");
        return;
      }
      if (item.id == 3 && this.roomId) {
        this.$router.push({
          path: "SERVECHAT",
          query: {
            id: this.roomId,
            oid: 0,
            s: 0,
            t: 0,
            remind: 0,
          },
        });
      } else if (item.id == 4) {
        this.$router.push({ path: item.path, query: { i: 2 } });
      } else {
        if (item.path) this.$router.push(item.path);
      }
    },
    signOut() {
      localStorage.clear();
      this.userinfo = null;
      this.$forceUpdate();
      this.$nextTick((callback=>{
        this.$refs.h1ele.src = HERF+'/backstage/sx/'+this.getRandomInt(1,13)+'.png'
      }))
      this.Toast.success("退出成功");
    },
    getUserInfo() {
      this.api.user().then((res) => {
        const obj = {
          ...JSON.parse(localStorage.getItem("user")),
          ...res.data,
        };
        localStorage.setItem("user", JSON.stringify(obj));
        this.userinfo = obj;
        console.log(this.userinfo.service);
        if (this.userinfo.service != 1) {
          this.getServiceRoomeId();
        }
      });
    },
    getServiceRoomeId() {
      this.api.getServiceRoomeId().then((res) => {
        this.roomId = res.data.roomId;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  width: 100%;
  height: 3.66rem;
  background-image: url("../../assets/mine/headback.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  .mine-info {
    margin-top: 0.26rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .mine-head-img {
      background: #ffffff;
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
      // overflow: hidden;
      border: 3px solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 100%;
        border-radius: 50%;
      }
      .edit-head-img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 0.31rem;
        height: 0.31rem;
        background: #ffffff;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        i {
          font-size: 12px;
          color: #3c3d52;
          transform: scale(0.7);
        }
      }
    }
    .mine-name {
      margin-top: 0.1rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: #ffffff;
    }
    .integral {
      background: rgba($color: #000000, $alpha: 0.6);
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0.24rem;
      padding: 0 0.12rem 0 0.06rem;
      height: 0.48rem;
      margin-top: 2px;
      img {
        display: inline-block;
        width: 0.38rem;
      }
      span {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 40px;
        color: #f3b953;
        margin-left: 0.16rem;
        margin-right: 0.2rem;
      }
      i {
        color: #a59ea7;
        font-size: 12px;
      }
    }
  }
}
.yf {
  height: 1.2rem;
  margin: 0 0.24rem;
  background: #edfbfb;
  border-radius: 0.2rem;
  box-shadow: 0 3px 6px rgba($color: #7b7b7b, $alpha: 0.16);
  display: flex;
  align-items: center;
  transform: translateY(-50%);
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: inline-block;
      width: 0.76rem;
    }
    span {
      font-size: 0.32rem;
      font-weight: 400;
      color: #666666;
      margin-bottom: 0.06px;
    }
    border-left: 1px solid #cccccc;
    &:first-child {
      border-left: none;
    }
  }
}
.mine-number {
  display: flex;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 0.3rem;
  > div:not(.fg-line) {
    flex: 1;
  }
  .fg-line {
    width: 1px;
    height: 0.38rem;
    background: #e6e6e6;
  }
  .mine-num {
    font-size: 0.4rem;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
  }
  .mine-num-text {
    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
  }
}
.order {
  margin-top: 0.5rem;
  .my-order {
    margin: 0 0.24rem;
  }
  .modular-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      font-size: 0.32rem;
      font-weight: 400;
      color: #666666;
      display: flex;
      align-items: center;
      .title-line {
        width: 4px;
        height: 16px;
        background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
        opacity: 1;
        border-radius: 0px 4px 4px 0px;
        margin-right: 6px;
      }
    }
    .look-more {
      font-size: 0.22rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 6px;
      }
      i {
        font-size: 0.2rem;
      }
    }
  }
  .order-type {
    display: flex;
    margin-top: 0.1rem;
    > div {
      flex: 1;
      position: relative;
      img {
        width: 100%;
      }
      .order-num {
        position: absolute;
        left: 0.3rem;
        top: 0.2rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #ffffff;
        text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.2);
        .order-n {
          font-size: 0.32rem;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
.menu {
  margin: 0.14rem 0.24rem;
  .menu-item {
    margin-bottom: 0.1rem;
    height: 0.88rem;
    background: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
    border-radius: 0.16rem;
    display: flex;
    align-items: center;
    padding: 0 0.26rem 0 0;
    &.none {
      display: none;
    }
    .left-icon {
      width: 0.32rem;
      padding-left: 0.3rem;
      display: flex;
      align-items: center;
      margin-right: 0.26rem;
      justify-content: center;
      img {
        width: 100%;
      }
    }
    .menu-title {
      flex: 1;
      font-size: 0.28rem;
      font-weight: 400;
      color: #666666;
    }
    .menu-more {
      i {
        font-size: 12px;
        color: #cccccc;
      }
    }
  }
  .outlogin {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.22rem;
    .menu-title {
      color: #f9647d;
      text-align: center;
    }
  }
}
</style>
